import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-yellow-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    d="M14.0188 6L6 14.0192V18H9.98121L18 9.98081L14.0188 6Z"
    fill={textColor}
  />
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <path
    d="M19.224 7.68018L8.95996 17.9448V23.0402H14.0559L24.32 12.7756L19.224 7.68018Z"
    fill={textColor}
  />
);

export const QuickFormIcon = createSlideIcon(Icon24x24, Icon32x32);
